import { jsx } from "react/jsx-runtime";
import { createSvgIcon } from "@mui/material";
const ExpandArrow = createSvgIcon(
  /* @__PURE__ */ jsx("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx(
    "path",
    {
      d: "M8 9.02469L10.8227 6.202C11.092 5.93267 11.5287 5.93267 11.798 6.202C12.0673 6.47133 12.0673 6.90799 11.798 7.17732L8.48766 10.4877C8.21833 10.757 7.78167 10.757 7.51234 10.4877L4.202 7.17732C3.93267 6.90799 3.93267 6.47133 4.202 6.202C4.47132 5.93267 4.90799 5.93267 5.17732 6.202L8 9.02469Z",
      fill: "#424242"
    }
  ) }),
  "ExpandArrow"
);
export {
  ExpandArrow
};
